import { createContext } from 'react';
export const FilePreviewMethodsContext = createContext(null);
